import React from 'react';
import { useIntl } from 'react-intl';
import { formatBytes } from '@/utils/fileHelper';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import CardItem from '@/components/cards/CardItem';
import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';
import AttachmentTypeFlag from '@/datasets/attachments/components/AttachmentTypeFlag';
import { attachmentIcon } from '@/datasets/attachments/helper';
import RequestAttachmentCardItemExtra from './RequestAttachmentCardItemExtra';

const RequestAttachmentCardItem = ({ attachment, onCheckBoxClick, onFolderClick }) => {
  const intl = useIntl();
  const { transferable } = attachment.metadata;
  const isRequired = transferable === ATTACHMENT_TRANSFER.required.name;
  const isRecommended = transferable === ATTACHMENT_TRANSFER.recommended.name;
  const { iconName } = attachmentIcon(attachment);

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    onFolderClick({ folder: { name: attachment.name, id: attachment.id } });
  };

  return (
    <CardItem className="aridhia-attachment-list-item" active={isRequired} warning={isRecommended}>
      <NameDescriptionCard
        active={false}
        disabled={isRequired}
        description={attachment.metadata.description}
        entity="attachment"
        icon={iconName}
        markdown
        meta={intl.formatMessage({ id: 'dataset.attachment.file.size' }, { size: formatBytes(attachment.size, false) })}
        name={attachment.name}
        onClick={handleClick}
        href={!!onFolderClick}
        onSelect={onCheckBoxClick ? () => onCheckBoxClick(attachment.id) : undefined}
        selected={isRequired || attachment.selected}
        withDescriptionShowMore
      >
        <AttachmentTypeFlag attachment={attachment} />
      </NameDescriptionCard>
      {(isRequired || isRecommended) && (<RequestAttachmentCardItemExtra transferable={transferable} />)}
    </CardItem>
  );
};

export default RequestAttachmentCardItem;
